import axios from '@/axios.js'

import { QuerySerialize } from '@/utils'
import { apolloClient } from '@/vue-apollo'
import { GET_SERVICE, GET_SERVICES } from '@/store/services/moduleServicesGraphql'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createService(context, serviceData) {
    return new Promise((resolve, reject) => {
      axios
        .post('services', serviceData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countServices(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`services/count/?${query}`)
        .then(response => {
          context.commit('SET_SERVICES_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchServices(context) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_SERVICES,
          variables: {
            filter: {
              query: context.state.query,
              skip: context.state.skip,
              limit: context.state.limit,
              sort: context.state.sort
            }
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_SERVICES', response.data.services)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchService(context, serviceId) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_SERVICE,
          variables: {
            id: serviceId
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_SERVICES', response.data.service)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchServicePlace(context, serviceId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`services/${serviceId}/place`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchServiceEmployee(context, serviceId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`services/${serviceId}/employee`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeService(context, serviceId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`services/${serviceId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editService(context, service) {
    return new Promise((resolve, reject) => {
      axios
        .put(`services/${service.id}`, service.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
